import store from "@/store";

const selectBreakpoints = (currentBreakpoint) => {
  let breakpoints = Object.keys(store.state.rwd.breakpoints);
  const index = breakpoints.findIndex((b) => b === currentBreakpoint);
  return breakpoints.slice(index);
};

const parseCurrentBrekPoint = () => {
  let width = window.innerWidth;
  let breakpoints = store.state.rwd.breakpoints;
  let currentBreakPoint = breakpoints[0];

  Object.keys(breakpoints).forEach((point, index) => {
    if (index !== 0) {
      if (width >= breakpoints[point]) {
        currentBreakPoint = point;
      }
    } else {
      if (width <= breakpoints[point]) {
        currentBreakPoint = point;
      }
    }
  });

  store.commit("rwd/UPDATE_BREAK_POINT", currentBreakPoint);
};

window.addEventListener("resize", parseCurrentBrekPoint);

parseCurrentBrekPoint();

import page from "@/config/page";

export default {
  computed: {
    $breakPoint() {
      return store.state.rwd.currentBreakPoint;
    },
    isMobile() {
      return page.layout == "mobile";
    },
  },
  methods: {
    mediaMatch(bp) {
      let plusModifier = !Array.isArray(bp) && bp.slice(-1) === "+";
      let mBp = plusModifier ? bp.slice(0, -1) : Array.isArray(bp) ? bp : [bp];
      let activePoints = plusModifier ? selectBreakpoints(mBp) : mBp;
      return activePoints.includes(this.$breakPoint);
    },
  },
};
